var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TimePickerControl } from './TimePickerControl';
import { formatValue } from '../formatValue';
import { DEFAULT_TEXTS } from '../helpers';
export var defaultTimePickerControlValueFormatter = function (_a) {
    var value = _a.value, is12Hours = _a.is12Hours, texts = _a.texts;
    var uiTexts = __assign({ am: DEFAULT_TEXTS.am, pm: DEFAULT_TEXTS.pm }, texts);
    return value ? formatValue(value, is12Hours, uiTexts) : '';
};
export function createDefaultTimePickerControl(_a) {
    var valueFormatter = (_a === void 0 ? {
        valueFormatter: defaultTimePickerControlValueFormatter
    } : _a).valueFormatter;
    return function defaultTimePickerControlRenderer(_a) {
        var className = _a.className, testId = _a.testId, disabled = _a.disabled, active = _a.active, opened = _a.opened, actions = _a.actions, focused = _a.focused, value = _a.value, placeholder = _a.placeholder, is12Hours = _a.is12Hours, error = _a.error, texts = _a.texts, control = _a.control, style = _a.style, rest = __rest(_a, ["className", "testId", "disabled", "active", "opened", "actions", "focused", "value", "placeholder", "is12Hours", "error", "texts", "control", "style"]);
        return (React.createElement(TimePickerControl, __assign({}, rest, { className: className, testId: testId, placeholder: placeholder, actions: actions, disabled: disabled, focused: focused, active: active, error: error, opened: opened, value: valueFormatter === null || valueFormatter === void 0 ? void 0 : valueFormatter({
                value: value,
                is12Hours: is12Hours,
                texts: texts
            }), control: control, style: style })));
    };
}
//# sourceMappingURL=defaultTimePickerControlRenderer.js.map